<template>
  <div class="text-white">
    <!-- Card contents -->

    <div class="text-left w-full">
      <!--              <div class="inline-flex items-center justify-center text-center align-middle relative">-->
      <div class="">
        <h2 class="border-gray-400 border-solid border-b-2 font-light leading-normal tracking-widest">
          LANGUAGES</h2>
      </div>
    </div>

    <div class="py-4 flex text-white">
      <table class="table-auto">
        <thead>
        <tr>
          <th>Language</th>
          <th>Understanding</th>
          <th>Speaking</th>
          <th>Writing</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Dutch</td>
          <td>Mothertongue</td>
          <td>Mothertongue</td>
          <td>Mothertongue</td>
        </tr>
        <tr class="bg-emerald-200">
          <td>English</td>
          <td>Mothertongue</td>
          <td>Mothertongue</td>
          <td>Mothertongue</td>
        </tr>
        <tr>
          <td>French</td>
          <td>Mothertongue</td>
          <td>Mothertongue</td>
          <td>Mothertongue</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
export default {
name: "Languages",
  // props: {
  //   propName: {
  //     type: Number,
  //     default: 0
  //   },
  // },
  data() {
    return {
    }
  },
}
</script>

<style scoped lang="scss">

</style>
